export const environment = {
  production: false,
  BASE_URL: '',
  baseUrl: 'http://localhost:8000',

  // siteUrl: 'http://localhost:4200',
  siteUrl: 'https://lab.observancedev.com/hsc',
  // ----------------------------------Laravel Api -------------------
  // User Api--------------------->
  apiendpoint: 'https://gu4h83u9tk.execute-api.ap-south-1.amazonaws.com', // getway service
    // apiendpoint: ' https://path.observancedev.com/gateway',
  //   apiendpoint: 'http://localhost:8001',
    // apiendpoint: 'https://pklm9lg2ei.execute-api.ap-south-1.amazonaws.com', // devlopment

  UserApiendpoint: 'https://gu4h83u9tk.execute-api.ap-south-1.amazonaws.com', // getway service
  // UserApiendpoint: 'http://localhost:8005',//getway service
    // UserApiendpoint: 'https://path.observancedev.com/gateway', // devlopment
    // UserApiendpoint: 'https://pklm9lg2ei.execute-api.ap-south-1.amazonaws.com', // devlopment

  // Setting Api----------------->
//   SettingsApiendpoint: 'https://path.observancedev.com/setting',
  SettingsApiendpoint: 'https://jzbx08n7h4.execute-api.us-east-1.amazonaws.com',
//   SettingsApiendpoint: 'http://localhost:8005',
//   SettingsApiendpoint: 'https://bt9btmxe86.execute-api.us-east-1.amazonaws.com', // devlopment


  // Order Api-------------------->
//   OrderApiendpoint:'https://au0li0z2fk.execute-api.us-east-1.amazonaws.com', // devlopment
//   OrderApiendpoint: 'https://path.observancedev.com/orders',
  OrderApiendpoint: 'https://8x6nb40107.execute-api.us-east-1.amazonaws.com',
//   OrderApiendpoint: 'http://localhost:8003',

  // Customer Api --------------->
//   DosApiendpoint: 'https://path.observancedev.com/customers', // customer
  DosApiendpoint: 'https://7o6li8q6lc.execute-api.us-east-1.amazonaws.com', // customer
  // DosApiendpoint:'http://localhost:8001',
  //   CustomerApiendpoint:'http://localhost:8001',
  //   EnduserApiendpoint:'http://localhost:8001',
//   CustomerApiendpoint: 'https://path.observancedev.com/customers', // customer
  CustomerApiendpoint: 'https://7o6li8q6lc.execute-api.us-east-1.amazonaws.com', // customer
  //CustomerApiendpoint:'http://localhost:8001',

  LablocationApiendpoint:
    'https://7o6li8q6lc.execute-api.us-east-1.amazonaws.com',

  CouponApiendpoint: 'https://7o6li8q6lc.execute-api.us-east-1.amazonaws.com',

  // Endusers
  EnduserApiendpoint: 'https://7o6li8q6lc.execute-api.us-east-1.amazonaws.com',
//   EnduserApiendpoints: 'https://path.observancedev.com/endusers', //ftp
  EnduserApiendpoints: 'https://33y5ylnxka.execute-api.ap-south-1.amazonaws.com',
//   EnduserApiendpoints:'https://wh755xk77h.execute-api.ap-south-1.amazonaws.com', //dev
//   EnduserApiendpoints:'http://127.0.0.1:8002',

  // Support Api ----------------->
  SupportApiendpoint: 'https://unvzn2ubt7.execute-api.ap-south-1.amazonaws.com',

  // Sales
  SalesApiendpoint: 'https://iz6yt7fcx2.execute-api.us-east-1.amazonaws.com', // missing
  // SalesApiendpoint:'http://localhost:8009',

  // add-dos?t=dos

  // ----------------------------------- Node api -------------------------------
  RunnerApiendpoint:
    'https://5akhb7jbxj.execute-api.us-east-1.amazonaws.com/api',
  // RunnerApiendpoint:'http://localhost:5050/api',
  //   LocaionApiendpoint:'https://j2hfbnonda.execute-api.us-east-1.amazonaws.com/api',
  //   LocaionApiendpoint:'http://localhost:3000/api',
  LocaionApiendpoint:
    'https://j2hfbnonda.execute-api.us-east-1.amazonaws.com/api',
  //  LocaionApiendpoint:'http://localhost:3000/api',
  TaskApiendpoint: 'https://14wchewgqk.execute-api.us-east-1.amazonaws.com/api',
  leaveApiendpoint:
    'https://ti6mxifnw7.execute-api.ap-south-1.amazonaws.com/api',
  // PhleboApiendpoint:'http://localhost:8086/api',
  PhleboApiendpoint:
    'https://jtu2tmipvc.execute-api.us-east-1.amazonaws.com/api',
  PlanApiendpoint: 'https://0gw95m38a5.execute-api.us-east-1.amazonaws.com/api',
  TestReportApiendpoint:
    'https://wh755xk77h.execute-api.ap-south-1.amazonaws.com/api',
  PartnerApiendpoint:
    'https://efjpe16r8e.execute-api.us-east-1.amazonaws.com/api', // missing

  AiApiendpoint: 'https://jtu2tmipvc.execute-api.us-east-1.amazonaws.com/api',
  //   AiApiendpoint:'https://d64c494abf5e.ngrok-free.app',
  firebaseConfig: {
    apiKey: 'AIzaSyC7FQ5BISV3cfA6Gkz4pihTIEGkpFFyUHI',
    authDomain: 'hsc-phlebotomist-app.firebaseapp.com',
    databaseURL: 'https://hsc-phlebotomist-app-default-rtdb.firebaseio.com/',
    projectId: 'hsc-phlebotomist-app',
    storageBucket: 'hsc-phlebotomist-app.firebasestorage.app',
    messagingSenderId: '893288284516',
    appId: '1:893288284516:android:877ee8406873c3f7843a71',
  },
};
